import { COLORS } from '@btime/constants'
import React from 'react'
import ControlledModal from '../../../../components/modals/ControlledModal'
import ModalHeader from './sections/ListTechnicianModalHeader.js'
import DataTable from '../../../../packages/kiti/components/table/DataTable.js'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination.js'
import { integrationsClient } from '../../../../utils/apollo/api.js'
import { gql } from '@apollo/client'
import Center from '../../../../components/helpers/Center.js'
import IconBlock from '../../../../components/presentation/IconBlock.js'
import Loading from '../../../../components/helpers/Loading.js'
import { useProjectId } from '@btime/react-session'
import PaginationControl from '../../../../components/helpers/PaginationControl.js'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'

const QUERY = gql`
  query SegwareAssociatedTechnicians($page: Int, $projectId: Int) {
    SegwareAssociatedTechnicians(page: $page, projectId: $projectId) {
      id
      segwareTechnicianId
      userName
      userId
    }
  }
`

const TechniciansAssociatedContent = () => {
  const currentProjectId = useProjectId()
  const [page, setPage] = React.useState(1)

  const { data, refetch, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page,
      projectId: currentProjectId
    },
    client: integrationsClient
  })

  const columns = [
    {
      label: 'Usuário',
      dataIndex: 'userName',
      flex: 0.5,
      render: text => <span style={{ fontWeight: 500 }}>{text}</span>
    },
    {
      label: 'ID do Técnico (Segware)',
      dataIndex: 'segwareTechnicianId',
      flex: 0.5,
      render: text => <span style={{ color: COLORS.grayDark }}>{text}</span>
    }
  ]

  return (
    <Grid gutter={0.2} align="center">
      <Col flex={1}>
        {data?.['SegwareAssociatedTechnicians']?.length ? (
          <DataTable
            rowKey="id"
            columns={columns}
            data={data?.['SegwareAssociatedTechnicians']}
            inPanel
            size="medium"
          />
        ) : (
          <Center height="100%">
            {!data ? <Loading /> : <IconBlock icon="BsInbox" title={'Nenhum dado encontrado'} />}
          </Center>
        )}
        <PaginationControl
          fetchMore={fetchMore}
          page={page}
          onChange={setPage}
          state={state}
          disabled={!data?.['SegwareAssociatedTechnicians']?.length}
        />
      </Col>
    </Grid>
  )
}

const ListSegwareTechnicianAssociatedModal = props => {
  return (
    <ControlledModal width="62rem" {...props}>
      <ModalHeader />
      <TechniciansAssociatedContent />
    </ControlledModal>
  )
}

export default ListSegwareTechnicianAssociatedModal
